export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-09.jpg'),
        title: 'クラウド',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'ハードウェア、ソフトウェア、ネットワークの統合',
      description: `<p style="font-size:1.05rem">クラウドはWANやLAN上のハードウェア、ソフトウェア、ネットワークリソースなどを統合し、データの計算、保管、処理、共有を可能にします。インターネット産業の発展に伴い、各プロジェクトは固有の識別情報を持ち、バックエンドで論理処理を行う必要があります。さまざまなレベルのデータは個別に処理され、多くの業界データは強力なシステムによるバックアップを必要とします。これらはクラウドコンピューティングにより実現されます。MaesInfoは強力なソフトウェア開発チームを基盤に、安定・信頼・安全で持続可能なクラウドサービスを提供します。</p>`
    },
    {
      title: '当社のサービスには以下が含まれます：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-09.jpg')+`)"></span>
      <span class="list">
      <i></i>モバイル連携<br/>
      <i></i>SAP<br/>
      <i></i>オフィスクラウド<br/>
      <i></i>上位クラウドへの移行<br/>
      <i></i>企業向けクラウドストレージ<br/>
      <i></i>ログ分析

      </span>`
    }
  ]
}
